cb.define([], function () {
  var RM_rm_contribution_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      viewmodel.getGridModel().setShowSubtotal(true);
	  
	  viewmodel.on('afterLoadData', function (data){
			viewmodel.get("contributionDetail").setDirty(true);
	  });
	  
		viewmodel.on('beforeSave', function (args) {
		debugger
		
		var data = JSON.parse(args.data.data);
		if(data.contributionDetail.length > 0)
		{
			var rows = data.contributionDetail;
			var sum = 0;
			rows.forEach(function(item,index){
				if(item.amountReceivable != undefined && item.amountReceivable != 0)
					sum = (parseFloat(sum*1) + parseFloat((item.amountReceivable)*1)).toFixed(2);
			});
			data.sumOfMoney = sum;
			args.data.data = JSON.stringify(data);
		}
	});
    }
  }
  try {
    module.exports = RM_rm_contribution_VM_Extend;
  } catch (error) {

  }
  return RM_rm_contribution_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/RM/RM_rm_contribution_VM.Extend.js